/**
 * [사용 불가] 창(사유 · 글) — 장 하나 · 고른 장들을 빼는 개별 조정. 실물 탭과 실물 상세가 같은 창을 쓴다(현민 2026-11-03 · VOCABULARY "재고 조정").
 * 수량 조정(재고 상세)은 stock-adjust-dialog. 그리기만 — 상태는 각 View 의 this.data.
 */
import type { ERetiredReason, UnitRetireInput, UnitView } from '../api/client';
import { E_RETIRED_REASONS } from '../api/client';
import { escapeHtml } from '../lib/cells';
import { STATUS_WORD } from './unit-table';
import type { EStockStatus } from '../api/client';

/** [사용 불가] 창의 초안 — 옮길 장 · 사유 · 글. null 이면 창이 닫혀 있다 */
export type RetireDraft = { unit_ids: string[]; reason: ERetiredReason; note: string };

export const RETIRED_REASON_WORD: Record<ERetiredReason, string> = { lost: '분실', damaged: '파손', disposed: '폐기', etc: '기타' };
/** 사용 불가로 갈 수 있는 상태 — 서버 RETIRABLE_STATUSES 와 같은 셋(328 트리거의 retired 전이) */
export const RETIRABLE_STATUSES: readonly EStockStatus[] = ['inspecting', 'available', 'asset'];

/** 이 장을 사용 불가로 옮길 수 있나 — null 이면 된다, 글이면 안 되는 까닭(서버 409 와 같은 판정) */
export function retireBlockOf(unit: UnitView): string | null {
  if (unit.parent_unit_id !== null) return '서버 안 부품 — 서버째';
  if (unit.stock_status === 'reserved') return '판매에 묶임 — 판매에서 먼저 풂';
  return RETIRABLE_STATUSES.includes(unit.stock_status) ? null : `${STATUS_WORD[unit.stock_status]} — 검수 중 · 가용 · 자산만`;
}

/** [실행] 이 켜지나 — 기타면 글이 있어야 한다 */
export function isRetireReady(draft: RetireDraft): boolean {
  return draft.reason !== 'etc' || draft.note.trim() !== '';
}

/** 서버에 보낼 몸 — 글은 trim, 빈 글은 null */
export function retireInputOf(draft: RetireDraft): UnitRetireInput {
  const note = draft.note.trim();
  return { unit_ids: draft.unit_ids, retired_reason: draft.reason, note: note === '' ? null : note };
}

/** [사용 불가] 창 — 사유 넷(라디오) · 글 한 줄 · [취소] [실행]. 이벤트: retire-reason(change) · retire-note(input) · retire-cancel · retire-confirm */
export function renderRetireDialog(draft: RetireDraft, bActing: boolean): string {
  const reasons = E_RETIRED_REASONS.map((reason) => `
    <label class="pv-retire-reason"><input type="radio" name="retire-reason" data-action="retire-reason" value="${reason}" ${draft.reason === reason ? 'checked' : ''}> ${RETIRED_REASON_WORD[reason]}</label>`).join('');
  const placeholder = draft.reason === 'etc' ? '기타 — 무슨 일인지 한 줄(필수)' : '덧붙일 말 한 줄(선택)';
  return `
    <div class="mg-wrap" role="dialog" aria-label="사용 불가">
      <div class="mg-overlay" data-action="retire-cancel"></div>
      <div class="mg-dialog pv-hold-dialog">
        <h3 class="mg-title">사용 불가 ${draft.unit_ids.length}장</h3>
        <p class="mg-note">재고에서 뺍니다 — 보유 · 가용에서 빠지고 이력에 사유가 남습니다. 홀딩 중이면 같이 풉니다. 잘못 뺐으면 실물의 [다시 찾음] 으로 검수 중에 돌아옵니다.</p>
        <div class="pv-retire-reasons">${reasons}</div>
        <input type="text" class="pv-hold-note" data-action="retire-note" placeholder="${placeholder}" value="${escapeHtml(draft.note)}">
        <div class="mg-buttons">
          <button type="button" class="btn-ghost" data-action="retire-cancel">취소</button>
          <button type="button" class="btn-primary" data-action="retire-confirm" ${!isRetireReady(draft) || bActing ? 'disabled' : ''}>${bActing ? '보내는 중…' : '사용 불가로'}</button>
        </div>
      </div>
    </div>`;
}
